import { defineStore } from "pinia";
import { login } from "@/api/auth/login";
import { getUserMenuList } from "@/api/menu";
import { getJWT, removeJWT } from "@/utils/token";
import envs from "@/envs";

export const useUserStore = defineStore("user", {
  state: () => ({
    userId: "",
    userName: "",
    userVendCd: "",
    token: "",
    roles: [],
    buttonPermission: "",
    myMenu: [],
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage, // 또는 sessionStorage
        paths: ["userId", "userName", "token", "myMenu"], // 저장할 항목 선택
      },
    ],
  },
  actions: {
    async loginByPassword(userInfo) {
      try {
        const searchParams = {
          CUID: `${userInfo.userId?.trim()}@${envs.companyCode}`,
          PASSWORD: userInfo.userPassword?.trim(),
          NEWPASSWORD: "",
        };

        const res = await login(searchParams);

        console.log('res._Result', res._Result);
        
        this.userId = res._Result.Userid;
        this.userName = res._Result.USER_KR_NAME;
        this.userVendCd = res._Result.USER_EN_NAME;
        this.token = getJWT(); // 쿠키나 로컬스토리지에서 토큰 가져오기

        // 로그인 성공 후 사용자 아이디로 메뉴 로드
        await this.fetchUserMenu(this.userId);

        return res;
      } catch (error) {
        console.error("loginByPassword 실패:", error);
        throw error;
      }
    },

    /**
     * 사용자 아이디로 메뉴 목록 조회 및 상태 저장
     * @param {string} [id] - 사용자 아이디 (생략 시 현재 state.userId 사용)
     */
    async fetchUserMenu(id) {
      try {
        const targetUserId = id || this.userId;
        const menuList = await getUserMenuList(targetUserId);
        this.myMenu = menuList || [];
        return this.myMenu;
      } catch (error) {
        console.error("fetchUserMenu 실패:", error);
        return [];
      }
    },

    clearSession() {
      this.userId = "";
      this.userName = "";
      this.userVendCd = "";
      this.token = "";
      this.roles = [];
      this.buttonPermission = "";
      this.myMenu = [];
      removeJWT();
    },
  },
});
